<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused.value"
    :applied-options="control.appliedOptions.value"
    :error="control.control.value.errors"
  >
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import type { ControlElement } from '@jsonforms/core';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import ControlWrapper from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import dayjs from 'dayjs';

  const props = defineProps(rendererProps<ControlElement>());
  const control = useWidgetControl(useJsonFormsControl(props));

  onMounted(() => {
    control.onChange(dayjs.tz.guess());
  });
</script>

<style scoped></style>
